export const isVcht = ['afisha.dop.edu.ru'].includes(window.location.hostname)
  || window.localStorage.getItem('active_api') === 'https://api.dop.edu.ru/v1';

export const isVrn = ['pfdo-events.govvrn.ru'].includes(window.location.hostname)
  || window.localStorage.getItem('active_api') === 'https://pfdo-eventsapi.govvrn.ru/v1';

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i
  .test(navigator.userAgent);

const userAgent = navigator.userAgent || '';
export const isSafari = /safari/i.test(userAgent)
  && !/android|chrome|chromium|crios|fxios|edg|opios|opr|firefox/i.test(userAgent);

export const isMobileSafari = isSafari && (/iPhone|iPad|iPod/i.test(userAgent)
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export const isApple = /iPhone|iPad|iPod|Mac|iPad Simulator|iPhone Simulator|iPod Simulator/i.test(navigator.userAgent);

export const isProductionMode = process.env.VUE_APP_MODE_NAME === 'production';

export const isDevelopmentMode = process.env.VUE_APP_MODE_NAME === 'development';

export const isVchtMode = process.env.VUE_APP_MODE_NAME === 'vcht';
